var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_c('v-form',{attrs:{"value":_vm.valid},on:{"input":_vm.handle,"blur":_vm.handle,"lazy":_vm.handle,"submit":function($event){$event.preventDefault();}}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }